import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "components/Loader";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom";
import WellnessService from "services/WellnessService";
import ProgressBar from "components/Progressbar";
import UserDefaultAvatar from "assets/img/user.svg";
import { useTeamContext } from "store/contexts/teamContext";

const styles = {
  responseDiv: {
    borderBottom: "1px solid #e9e9e9",
    padding: "10px",
  },
  count: {
    fontSize: "20px",
    fontWeight: "bold",
  },
};

export default ({ onClose, triviaId }) => {
  const classes = styles;
  const params = useParams();
  const [surveyData, setSurveyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("list");
  const [answers, setAnswers] = useState([]);
  const [percentage, setPercentage] = useState({
    correct: 0,
    inCorrect: 0
  });
  const { team } = useTeamContext();

  useEffect(() => {
    setLoading(true);
    WellnessService.viewTriviaResponses(triviaId, params.teamId).then((res) => {
      setSurveyData(res.data);
      setLoading(false);
    });
  }, [triviaId, params.teamId]);

  const swtichView = () => {
    setType(type === "list" ? "view" : "list");
  };
  const viewAnswers = (ans) => {

    let correct = ans.correct_response !== 0 ? (ans.correct_response / team.users.length) * 100 : ans.correct_response;
    let inCorrect = ans.incorrect_response !== 0 ? (ans.incorrect_response / team.users.length) * 100 : ans.incorrect_response;

    setPercentage({
      correct: correct,
      inCorrect: inCorrect
    });

    setAnswers(ans);
    swtichView();
  };

  return (
    <Modal
      center
      closeOnEsc={false}
      closeOnOverlayClick={false}
      styles={{
        modal: {
          maxWidth: "40%",
          width: "40%",
          borderRadius: "10px",
        },
      }}
      open
      onClose={() => {
        if (type === "list") {
          onClose(false);
        } else {
          swtichView();
        }
      }}
    >
      <div className="pt-4">
        {loading && (
          <div className="d-flex justify-content-center">
            <Loader />
          </div>
        )}
        {surveyData.length > 0 &&
          !loading &&
          type === "list" &&
          surveyData.map((resp) => (
            <div style={classes.responseDiv}>
              <h6>
                {resp.question}
                <span class="badge badge-primary badge-pill text-primary">
                  {resp.type}
                </span>
              </h6>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  Total response(s){" "}
                  <span style={classes.count}>{resp.total_response}</span> From{" "}
                  <span style={classes.count}>{resp.total_user}</span> member(s){" "}
                </div>
                <div>
                  <button
                    className="btn btn-light"
                    onClick={() => viewAnswers(resp)}
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          ))}
        {type === "view" && (
          <div>
            <div className="d-flex align-items-basline">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={swtichView}
                style={{ cursor: "pointer", fontSize: "1rem" }}
              />
              <p style={{ marginLeft: "1rem", fontSize: "1rem" }}>
                {answers.question}
              </p>
            </div>
            <div
              className="d-flex"
              style={{
                justifyContent: "space-evenly",
                alignItems: "center",
                flexDirection: "column"
              }}
            >
              <div style={{
                height: "60px",
                width: "100%",
                position: "relative",
                fontWeight: 500
              }}>
                <span style={{
                  position: "absolute",
                  paddingTop: "5px",
                  paddingLeft: "5px"
                }}>Correct</span>
                <ProgressBar
                  position="absolute"
                  right={0}
                  color={"black"}
                  completed={percentage.correct}
                  progressPercentage={percentage.correct}
                  height={30}
                  border="1px solid #9e9e9e80"
                  borderRadius={5}
                  bgcolor={"#B3DDC7"}
                />
                {answers.users_with_correct_answer.map((ans, index) => (
                  <img src={ans.avatar ?? UserDefaultAvatar} alt="user-avatar" style={{ width: '20px', borderRadius: '50%', objectFit: "cover", height: "20px", position: "absolute", bottom: "5px", left: `${index * 13}px` }} className="correct-user-avatar" />
                ))}
              </div>
              <div style={{
                height: "60px",
                width: "100%",
                position: "relative",
                paddingTop: "5px",
                fontWeight: 500
              }}>
                <span style={{
                  position: "absolute",
                  paddingTop: "5px",
                  paddingLeft: "5px"
                }}>InCorrect</span>
                <ProgressBar
                  position="absolute"
                  right={0}
                  color={"black"}
                  completed={percentage.inCorrect}
                  progressPercentage={percentage.inCorrect}
                  height={30}
                  border="1px solid #9e9e9e80"
                  borderRadius={5}
                  bgcolor={"#f4bebe"}
                />
                {answers.users_with_incorrect_answer.map((ans, index) => (
                  <img src={ans.avatar ?? UserDefaultAvatar} alt="user-avatar" style={{ width: '20px', borderRadius: '50%', objectFit: "cover", height: "20px", position: "absolute", bottom: "0", left: `${index * 13}px` }} />
                ))}
              </div>
            </div>
          </div>
        )}
        <div className="mt-2 d-flex justify-content-end">
          <button onClick={() => onClose(false)} className="btn btn-danger">
            Close
          </button>
        </div>
      </div>
    </Modal >
  );
};
